module.exports = __webpack_public_path__ + "img/oops.c1a37cf1.svg";